import { createStore, combineReducers, applyMiddleware } from 'redux';
import undoable, { excludeAction, includeAction } from 'redux-undo';
import ReduxThunk from 'redux-thunk';
import isLoading from '../reducers/LoadingReducer';
import EditorReducer from '../reducers/EditorReducer';
import TagReducer from '../reducers/TagReducer';
import TagWizardReducer from '../reducers/TagWizardReducer';

import AddressReducer from '../reducers/AddressReducer';
import ProductReducer from '../reducers/ProductReducer';
import ProductVariationReducer from '../reducers/ProductVariationReducer';
import InStoreProductReducer from '../reducers/InStoreProductReducer';
import CouponReducer from '../reducers/CouponReducer';
import ReferralCouponReducer from '../reducers/ReferralCouponReducer';

import CartReducer from '../reducers/CartReducer';
import CreditCardReducer from '../reducers/CreditCardReducer';
import PICNumberReducer from '../reducers/PICNumberReducer';
import UserReducer from '../reducers/UserReducer';
import PurchasingUserReducer from '../reducers/PurchasingUserReducer';

import GlobalConfigReducer from '../reducers/GlobalConfigReducer';

const logger = (store) => (next) => (action) => {
    const returnValue = next(action);
    console.log(action, store.getState());
    return returnValue;
};
const loading = (store) => (next) => (action) => {
    const state = store.getState();
    if (action.type !== 'TOGGLE_LOADING' && state.isLoading) {
        console.log('Waiting...');
        return;
    }
    return next(action);
};

const reducers = combineReducers({
    isLoading,
    // editor: EditorReducer,
    editor: undoable(EditorReducer, {
        filter: excludeAction([
            // NOTE: put here all the actions that are used whenever a layer is active so we dont record those actions in the history
            // 'ADD_NEW_LAYER',
            // 'REMOVE_LAYER',
            'ADD_LAYER_ERROR',
            'REMOVE_LAYER_ERROR',
            'CHANGE_LAYER_FIELD',
            'CHANGE_LAYER_TYPE_FIELD',
            'CHANGE_LAYER_TYPE',
            'CHANGE_LAYER_SCALE',
            'CHANGE_LAYER_POSITION', // Object position
            'CHANGE_LAYER_ROTATION', // Rotate
            'CHANGE_LAYER_TEXTORIENTATION', // Mirror effect (upside down / leftright flip )
        ]),
    }),
    tag: TagReducer,
    tagWizard: undoable(TagWizardReducer, {
        filter: includeAction(['TAG_WIZARD_CHANGE_SCREEN']),
    }),
    address: AddressReducer,
    user: UserReducer,
    purchasingUser: PurchasingUserReducer,
    cart: CartReducer,
    product: ProductReducer,
    productVariation: ProductVariationReducer,
    inStoreProduct: InStoreProductReducer,
    coupon: CouponReducer,
    referralCoupon: ReferralCouponReducer,
    creditCard: CreditCardReducer,
    picNumber: PICNumberReducer,
    globalConfig: GlobalConfigReducer,
});

export let store = createStore(
    reducers,
    applyMiddleware(ReduxThunk, loading, logger)
);
